<template>
  <div class="section-container">
    <the-header ref="theHeader" />

    <main class="dashboard-content">
      <iframe
        class="viz-frame"
        :src="url"
        title="EMR Dashboard"
      ></iframe>
    </main>

    <the-footer />
  </div>
</template>

<script>
import theHeader from '../../about/layout/theHeader.vue';
import theFooter from '../../about/layout/theFooter.vue';

export default {
  name: 'EMRDashboard',
  components: {
    theHeader,
    theFooter,
  },
  data() {
    return {
      url: 'https://public.tableau.com/shared/5M7D96G5H?:display_count=n&:origin=viz_share_link:showVizHome=no&:embed=true',
    };
  },
};
</script>

<style scoped>
.section-container {
  min-height: calc(100vh - 35px);
}

.dashboard-content {
  width: 100%;
  padding: 1rem;
}

.viz-frame {
  width: 100%;
  height: 85vh;
  border: none;
  display: block;
}

@media (max-width: 576px) {
  .dashboard-content {
    padding: 0.5rem;
  }

  .viz-frame {
    height: 90vh;
  }
}
</style>
